<template>
    <div class="xt-radio" @click="onTextClick">
        <img src="../assets/option-default.svg" class="xt-radio__unchoose" v-show="!currentValue" @click.stop="changeValue" />
        <img src="../assets/correct.svg" class="xt-radio__chosed" v-show="currentValue" @click.stop="changeValue" />
        <div class="xt-radio__content">
            <slot/>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    preventTextClick: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    }
  },
  methods: {
    changeValue() {
      this.$emit('input', !this.currentValue)
    },
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    onTextClick() {
      if (this.preventTextClick) {
        return
      }
      this.changeValue()
    }
  }
}
</script>
<style lang="less" scoped>
.xt-radio{
    display: flex;
    height: 17px;
    line-height: 17px;
    .xt-radio__unchoose{
        width: 18px;
        height: 18px;
        margin-right: 3px;
    }
    .xt-radio__chosed{
        width: 18px;
        height: 18px;
        margin-right: 3px;
    }
    .xt-radio__content{
        height: 18px;
        line-height: 18px;
    }
}
</style>